// from https://stackoverflow.com/a/36862446/4564156

import { useState, useEffect } from 'react';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  
  // Read the CSS environment variable from the document root
  const safeAreaBottomRaw = getComputedStyle(document.documentElement)
    .getPropertyValue('--safe-area-inset-bottom') || '0px';
    
  // Convert the pixel string (e.g., "34px") into a floating-point number
  const safeAreaBottom = parseFloat(safeAreaBottomRaw) || 0;

  return {
    width,
    height: height + safeAreaBottom
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
